// any app specific constants that you don't want to keep in config can go here.
export const devEnvironment = ["localhost", "alpha", "beta"].some((env) => window.location.hostname.includes(env));

export const SYSTEM_ERROR = "System error. Please try again later!";
export const CTA_YES = "Yes";
export const CTA_NO = "No";
export const CTA_CANCEL = "Cancel";
export const DEV = 1;
export const IS_LOCALHOST = window.location.origin.includes("localhost") ? 1 : 0;
// export const IS_LOCALHOST = 0;
export const BASE_URL = "/admin/v1";

export const ENCRYPT_KEY = import.meta.env.REACT_APP_ENCRYPT_KEY;
export const ENC_KEY_AES256GCM = import.meta.env.REACT_APP_ENC_KEY_AES256GCM;
export const arrSigninAsAdminAuthId = [1, 2];
export const MS_CLIENT_ID = import.meta.env.REACT_APP_MS_CLIENT_ID;
export const GOOGLE_SIGN_IN_CLIENT_ID = import.meta.env.REACT_APP_GOOGLE_SIGN_IN_CLIENT_ID;
export const SSB_TUTORIAL_VIDEO_URL = "https://cdn2.jobspreader.com/jcd-misc/SSB-Tutorial-Alex-160925.mp4";
export const REACT_LOGIN_PATH = "/admin/v1/login";
//sss
